import { IdeaCoverPhotoUrl } from '@frontend/data-access';
import { Image } from 'antd';
import useTranslation from 'next-translate/useTranslation';

const NEXT_PUBLIC_UNSPLASH_PROJECT_NAME =
  process.env['NEXT_PUBLIC_UNSPLASH_PROJECT_NAME'];

export interface UnsplashImageProps {
  name: string;
  image: IdeaCoverPhotoUrl;
  size?: 'small' | 'medium';
}

export function UnsplashImage({
  name,
  image,
  size = 'medium',
}: UnsplashImageProps) {
  const { t } = useTranslation('common');
  const imageSize = size === 'small' ? 114 : 180;

  return (
    <div
      className={`md:min-w-[${imageSize}px] max-w-[${imageSize}px] ${
        size === 'small' ? 'mr-2' : 'mr-3'
      }`}
    >
      <div className="flex flex-col">
        <Image
          className="rounded-xl overflow-hidden"
          alt={name}
          width={imageSize}
          height={imageSize}
          src={image?.imageUrl}
          preview={false}
        />
        <div
          className={`${
            size === 'medium' ? 'w-[180px]' : ''
          } my-1 text-center text-wrap ${
            size === 'small' ? 'text-[8px]' : 'text-[10px]'
          }`}
        >
          {t('photo_by')}{' '}
          <a
            href={`${image?.profileUrl}?utm_source=${NEXT_PUBLIC_UNSPLASH_PROJECT_NAME}&utm_medium=referral`}
          >
            {image?.author}
          </a>{' '}
          {t('on')}{' '}
          <a
            href={`https://unsplash.com/?utm_source=${NEXT_PUBLIC_UNSPLASH_PROJECT_NAME}&utm_medium=referral`}
          >
            {t('unsplash')}
          </a>
        </div>
      </div>
    </div>
  );
}

export default UnsplashImage;
